import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { changeExpand } from "../../../redux/boardListSlice";
import { isAdmin } from "../../../utils/constants";
import { getDashboardBoardSections } from "../utils/dashboardUtils";

export function useBoardListState(boards = []) {
  const dispatch = useDispatch();
  const expanded = useSelector((state) => state.boardList.expanded);
  const searchBoard = useSelector((state) => state.search.boardSearchText);
  const includeAdminSections = isAdmin();

  const sections = React.useMemo(
    () =>
      getDashboardBoardSections({
        boards,
        searchText: searchBoard,
        includeAdminSections,
      }),
    [boards, includeAdminSections, searchBoard]
  );

  const handleAccordionChange = React.useCallback(
    (panel) => (event, isExpanded) => {
      event.stopPropagation();
      dispatch(changeExpand(panel, isExpanded));
    },
    [dispatch]
  );

  return {
    expanded,
    includeAdminSections,
    userBoards: sections.userBoards,
    allBoards: sections.allBoards,
    archivedBoards: sections.archivedBoards,
    handleAccordionChange,
  };
}
